import {makeContext} from '../../MakeContext/makeContext';
import {useKeyInfoQueryContext} from '../../MultiRunWorkspace/KeyInfoQueryContext';
import {useIsSingleRun} from '../../MultiRunWorkspace/SingleRunMode';
import {usePanelBankConfigWithRefs} from './usePanelBankConfigWithRefs';
import {usePanelBankSectionList} from './usePanelBankSectionList';

const useVisibleSections = () => {
  const panelBankConfigWithRefs = usePanelBankConfigWithRefs();
  const isSingleRun = useIsSingleRun();
  const {
    keyInfoQuery: {historyKeyInfo},
  } = useKeyInfoQueryContext();
  return usePanelBankSectionList({
    panelBankConfigWithRefs,
    isSingleRun,
    historyKeyInfo,
  });
};

export const {
  Provider: PanelBankVisibleSectionsProvider,
  hook: useVisibleSectionsContext,
} = makeContext<ReturnType<typeof useVisibleSections>>({
  contextType: 'PanelBankVisibleSections',
  getContextValue: useVisibleSections,
});
